import { ActiveQueue as Active } from "./active";
import { QueueHistory as History } from "./history";

export default {
    Active,
    History
};